<template>
  <div v-if="data.length > 0 && data != 0">
    <span v-for="(item, index) in data" :key="index">
      <span v-if="index > 0">,</span>      
      <span class="ml-1">{{ item.name }}</span>      
    </span>
  </div>
</template>

<script>

export default {
  name: 'ClientsToBooker',
  props: { 
    data:{
        type: Array, 
        default: () => [] 
    }        
  },
  data() {
    return {
    };
  },
  computed: {
  },
  watch: {
  },
  methods: {    
  },
  created() {    
  },
  mounted() {    
  }
};
</script>
